module.exports = __webpack_public_path__ + "static/strassenlandschaft-3abee71f7c5abee6f360774109a6aa66.PNG";